export const PATH = {
    TITUL: ['titul'],
    NAME: ['name'],
    SURNAME: ['surname'],
    NICKNAME: ['nickname'],
    DATE_OF_BIRTH: ['date_of_birth'],
    BIRTH_NUMBER_NONE: ['birth_number_none'],
    BIRTH_NUMBER: ['birth_number'],
    STREET: ['street'],
    STREET_NUMBER: ['street_number'],
    CITY: ['city'],
    PSC: ['psc'],
    NATIONALITY: ['nationality'],
    COUNTRY: ['country'],
    BANK: ['bank'],
    EMAIL: ['email'],
    PHONE: ['phone'],
    PHONE_PREFIX: ['phone_prefix'],
    ACCEPTANCE: ['acceptance'],
    SUHLAS_MKT: ['suhlas_mkt'],
    SERVER_INFO: ['server_info']
};
